interface ControlData {
  sensitivity?: number;
  specificity?: number;
  pretest?: number;
  [key: string]: any;
}

interface CalculatedData {
  pretest: number;
  sensitivity: number;
  specificity: number;
  posttest1pos: number;
  posttest1neg: number;
}

const updateFunc = (controlData: ControlData): CalculatedData => {
  const sensitivity =
    controlData["sensitivity"] !== undefined ? controlData["sensitivity"] : 95;
  const specificity =
    controlData["specificity"] !== undefined ? controlData["specificity"] : 95;
  const pretest =
    controlData["pretest"] !== undefined ? controlData["pretest"] : 50;
  const pretest1 = pretest;
  let sensitivity1 = sensitivity / 100;
  let specificity1 = specificity / 100;
  let lr_pos1 = sensitivity1 / (1 - specificity1);
  let lr_neg1 = (1 - sensitivity1) / specificity1;
  const start = 0;
  const end = 1;
  const increment = 0.001;
  const pretestrange1 = Array.from(
    { length: Math.ceil((end - start) / increment) + 1 },
    (_, index) => start + index * increment
  );
  let pretest_odds1 = pretestrange1.map((element) => element / (1 - element));
  pretest_odds1[pretestrange1.length - 1] = 100;
  let posttest_odds_pos1 = pretest_odds1.map((element) => element * lr_pos1);
  let posttest_odds_neg1 = pretest_odds1.map((element) => element * lr_neg1);
  let posttest_pos1 = posttest_odds_pos1.map(
    (element) => element / (1 + element)
  );
  let posttest_neg1 = posttest_odds_neg1.map(
    (element) => element / (1 + element)
  );
  posttest_neg1[pretestrange1.length - 1] = 1;
  let posttest1pos = 1;
  let posttest1neg = 1;
  sensitivity1 = sensitivity / 100;
  specificity1 = specificity / 100;
  lr_pos1 = sensitivity1 / (1 - specificity1);
  lr_neg1 = (1 - sensitivity1) / specificity1;
  pretest_odds1 = pretestrange1.map((element) => element / (1 - element));
  pretest_odds1[pretestrange1.length - 1] = 100;
  posttest_odds_pos1 = pretest_odds1.map((element) => element * lr_pos1);
  posttest_odds_neg1 = pretest_odds1.map((element) => element * lr_neg1);
  posttest_pos1 = posttest_odds_pos1.map((element) => element / (1 + element));
  posttest_neg1 = posttest_odds_neg1.map((element) => element / (1 + element));
  posttest_neg1[pretestrange1.length - 1] = 1;
  posttest1pos = posttest_pos1[pretest1 * 10 + 1] * 100;
  posttest1neg = posttest_neg1[pretest1 * 10 + 1] * 100;
  if (isNaN(posttest1pos)) {
    posttest1pos = 100;
  }
  if (isNaN(posttest1neg)) {
    posttest1neg = 100;
  }
  if (posttest1pos < 3) {
    posttest1pos = 0;
  }
  const calculatedData: CalculatedData = {
    pretest,
    sensitivity,
    specificity,
    posttest1pos: Math.round(posttest1pos),
    posttest1neg: Math.round(posttest1neg),
  };
  return calculatedData;
};
export default updateFunc;
